// FAQ.jsx
import React from 'react';

const FAQ = ({ title, faqData = [] }) => {
  return (
    <div>
      {title && <h1 className="text-center mb-4">{title}</h1>}

      {/* Native disclosure elements: the same pattern the rest of the site already uses, and
          they work with find-in-page and without JavaScript. */}
      <div className="faq mb-4">
        {faqData.map((item, index) => (
          <details className="faq-item" key={index}>
            <summary>{item.question}</summary>
            <div className="faq-answer">{item.answer}</div>
          </details>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
